<template>
    <div class="space-accordian">
        <ul class="space-accordian--list">
            <template v-for="item in data.values">
                <li v-if="item.answer" v-bind:key="item.question"
                    :class="selected === item.question ? 'is--selected' : ''">
                    <a href="#"
                       @click.prevent="selected === item.question ? selected = null : selected = item.question">
                       {{ item.question }}
                       <span>
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M8.95906 1.4751L5.69906 4.7351C5.31406 5.1201 4.68406 5.1201 4.29906 4.7351L1.03906 1.4751" stroke="#4D4D4D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </span>
                    </a>
                    <div class="space-accordian--expand" v-show="item.question === selected">

                        <span v-html="item.answer"></span>

                    </div>
                </li>
            </template>
        </ul>
    </div>
</template>


<script>
    export default {
        name: 'SpacesAccordian',
        data: () => ({
            selected: null,
            current_locale: null
        }),
        props: ['data'],
        components: {},
        mounted() {
            this.current_locale = current_locale;
        },
        methods: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-accordian {
  width: 100%;
}

.space-accordian--list {
    list-style: none;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    @include breakpoint(tablet-landscape) {
        gap: 16px;
    }

    li {
        padding: 32px;
        width: 100%;
        border-radius: 4px;
        color: $primary-grey;
        background: $light-grey;
        position: relative;
        &:last-child {
            border-bottom: 0;
            margin-bottom: 0;
        }
        &.is--selected {
            span {
                transform: rotate(-180deg) translate(0, -50%);
            }

            .space-accordian--expand {
                border-top: 1px solid $divider-dark;
            }
        }
    }

    a {
        color: $primary-grey;
        display: block;
        width: 100%;
        position: relative;
        @include responsive-text-size('Header--13--BOLD');

        span {
            width: 10px;
            height: 10px;
            position: absolute;
            right: 0px;
            top: calc(50% - 3px);
            transform: rotate(0deg) translate(0, -50%);
            @include ease-fast;
        }
    }

    .space-accordian--expand {
        margin-top: 16px;
        padding-top: 24px;
    }
}

.merlin-table {
    display: flex;
    flex-wrap: wrap;
    color: $strong-light;
    font-size: 14px;
    font-family: $font-regular;
    padding-left: 50px;
    margin-top: 50px;
    margin-bottom: 50px;

    @include breakpoint(tablet) {
        padding-left: 0px;
    }

}

.merlin-table__subtitle {
    color: $strong-light;
    font-size: 12px;
    font-family: $font-bold;
    margin-bottom: 5px;
    text-transform: uppercase;
}

.merlin-table__item {
    display: grid;
    grid-template-columns: 3fr 5fr;
    gap: 5px 20px;
    line-height: 15px;
    padding-bottom: 5px;
    border-bottom: 1px solid $strong-light;
    margin-bottom: 20px;

    &:last-child {
        border: 0;
    }
}

.merlin-table__item--full {
    display: flex;
}

.merlin-generic-schedule-container {
}

.merlin-generic-schedule-merlin-generic-schedule {
    height: auto;
    display: flex;
    width: 600px;
    margin: auto;
    padding: 50px;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    border-radius: 10px;
    flex-direction: column;
}

.merlin-generic-schedule-frame22 {
    border: 2px dashed rgba(120, 120, 120, 0.4);
    display: flex;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    margin-bottom: 40px;
    flex-direction: column;
}

.merlin-generic-schedule-frame26 {
    display: flex;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    flex-direction: column;
}

.merlin-generic-schedule-frame24 {
    display: flex;
    position: relative;
    align-items: center;
    border-color: transparent;
    margin-bottom: 20px;
}

.merlin-generic-schedule-frame221 {
    width: 140px;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-shrink: 0;
    border-color: transparent;
    margin-right: 10px;
    flex-direction: column;
}

.merlin-generic-schedule-text {
    color: $strong-light;
    height: auto;
    font-size: 12px;
    align-self: auto;
    text-align: left;
    font-family: $font-regular;
    font-weight: 700;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 5px;
    text-decoration: none;
}

.merlin-generic-schedule-group2 {
    width: 130px;
    height: 15px;
    display: flex;
    padding: 0;
    position: relative;
    align-self: auto;
    box-sizing: border-box;
    align-items: flex-start;
    flex-shrink: 1;
    border-color: transparent;
    border-style: none;
    border-width: 0;
    margin-right: 0;
    border-radius: 0px 0px 0px 0px;
    margin-bottom: 0;
    flex-direction: row;
    justify-content: flex-start;
    background-color: transparent;
}

.merlin-generic-schedule-text02 {
    color: $strong-light;
    height: auto;
    position: absolute;
    font-size: 14px;
    align-self: auto;
    font-style: Light;
    text-align: left;
    font-family: $font-regular;
    font-weight: 300;
    line-height: 15px;
    font-stretch: normal;
    text-decoration: none;
}

.merlin-generic-schedule-frame15 {
    display: flex;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    flex-direction: column;
}

.merlin-generic-schedule-text04 {
    color: $strong-light;
    height: auto;
    font-size: 12px;
    align-self: auto;
    font-style: Bold;
    text-align: left;
    font-family: $font-regular;
    font-weight: 700;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 5px;
    text-decoration: none;
}

.merlin-generic-schedule-text06 {
    color: $strong-light;
    height: auto;
    font-size: 14px;
    align-self: auto;
    /*font-style: Light;*/
    text-align: left;
    font-family: $font-regular;
    font-weight: 300;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 0;
    text-decoration: none;
}

.merlin-generic-schedule-vector3 {
    width: 450px;
    height: 0px;
    position: relative;
    align-self: stretch;
    margin-bottom: 20px;
    border-top: 1px solid $strong-light;
}

.merlin-generic-schedule-frame25 {
    display: flex;
    position: relative;
    align-items: center;
    border-color: transparent;
    margin-bottom: 20px;
}

.merlin-generic-schedule-frame222 {
    width: 140px;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-shrink: 0;
    border-color: transparent;
    margin-right: 10px;
    flex-direction: column;
}

.merlin-generic-schedule-text08 {
    color: $strong-light;
    height: auto;
    font-size: 12px;
    align-self: auto;
    font-style: Bold;
    text-align: left;
    font-family: $font-regular;
    font-weight: 700;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 5px;
    text-decoration: none;
}

.merlin-generic-schedule-text10 {
    color: $strong-light;
    height: auto;
    font-size: 14px;
    align-self: auto;
    font-style: Light;
    text-align: left;
    font-family: $font-regular;
    font-weight: 300;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 0;
    text-decoration: none;
}

.merlin-generic-schedule-frame151 {
    display: flex;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    flex-direction: column;
}

.merlin-generic-schedule-text12 {
    color: $strong-light;
    height: auto;
    font-size: 12px;
    align-self: auto;
    font-style: Bold;
    text-align: left;
    font-family: $font-regular;
    font-weight: 700;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 5px;
    text-decoration: none;
}

.merlin-generic-schedule-text14 {
    color: $strong-light;
    height: auto;
    font-size: 14px;
    align-self: auto;
    font-style: Light;
    text-align: left;
    font-family: $font-regular;
    font-weight: 300;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 0;
    text-decoration: none;
}

.merlin-generic-schedule-vector4 {
    width: 450px;
    height: 0px;
    position: relative;
    align-self: stretch;
    margin-bottom: 20px;
    border-top: 1px solid $strong-light;

}

.merlin-generic-schedule-frame223 {
    display: flex;
    position: relative;
    align-items: flex-start;
    border-color: transparent;
    flex-direction: column;
}

.merlin-generic-schedule-text16 {
    color: $strong-light;
    height: auto;
    font-size: 14px;
    align-self: auto;
    font-style: Light;
    text-align: left;
    font-family: $font-regular;
    font-weight: 300;
    line-height: 15px;
    font-stretch: normal;
    margin-right: 0;
    margin-bottom: 0;
    text-decoration: none;
}

@media(max-width: 767px) {
    .merlin-generic-schedule-merlin-generic-schedule {
        height: 332px;
        align-items: center;
        padding-top: 35px;
    }
}


</style>
